import { useNavigate } from 'react-router';

import { CARD_PARTNER_ONBOARDING_APPLY } from '@perpay-web/constants/paths';
import { useMount } from '@perpay-web/hooks/useMount';

const PhoExistingUserNotification = () => {
    const navigate = useNavigate();

    useMount(() => {
        navigate(`${CARD_PARTNER_ONBOARDING_APPLY}?existing_user=true`, {
            replace: true,
        });
    });
};

export default PhoExistingUserNotification;
